import React from 'react';
import * as Icon from 'react-feather';

export const SidebarData = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    id: 'dashboard',
    i18nTitle: 'dashboard',
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  // {
  //   title: 'Call Summary',
  //   href: '/call-summary',
  //   id: 2,
  //   icon: <Icon.BarChart size={20} />,
  //   collapisble: false
  // },
  // {
  //   title: 'My Callbacks',
  //   href: '/my-callbacks',
  //   id: 3,
  //   icon: <Icon.PhoneForwarded size={20} />,
  //   collapisble: false
  // },
  {
    title: 'My Call History',
    href: '/my-callhistory',
    id: 'my-callhistory',
    i18nTitle: 'liveCallHistory',
    icon: <Icon.PhoneCall size={20} />,
    collapisble: false
  },
  {
    title: 'Follow Up',
    href: '/follow-up',
    id: 'follow-up',
    i18nTitle: 'followUp',
    icon: <Icon.Clock size={20} />,
    collapisble: false
  }
  // {
  //   title: 'Meta Help Desk',
  //   href: '/meta-help-desk',
  //   id: 'meta-help-desk',
  //   i18nTitle: 'metaHelpDesk',
  //   icon: <Icon.BookOpen size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'Help Desk',
  //   href: '/help-desk',
  //   id: 6,
  //   icon: <Icon.HelpCircle size={20} />,
  //   collapisble: false
  // }
];

export const CrmSideBarData = [
  {
    title: 'CRM',
    href: '/crm',
    id: 'crm',
    i18nTitle: 'crm',
    icon: <Icon.Users size={20} />,
    collapisble: false
  }
  // {
  //   title: 'Help Desk',
  //   href: '/help-desk',
  //   id: 6,
  //   icon: <Icon.HelpCircle size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'product',
  //   href: '/product',
  //   id: 2,
  //   icon: <Icon.Package size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'Call Summary',
  //   href: '/call-summary',
  //   id: 2,
  //   icon: <Icon.BarChart size={20} />,
  //   collapisble: false
  // },
  // {
  //   title: 'Comments',
  //   href: '/comments',
  //   id: 3,
  //   icon: <Icon.MessageCircle size={20} />,
  //   collapisble: false
  // }
];

export const TenantSidebarData = [
  {
    title: 'Dashboard',
    href: '/tenant-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Reports',
    id: 2,
    href: '/reports',
    icon: <Icon.FileText size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Live Report',
        id: 3,
        subItems: [
          {
            title: 'Realtime Report',
            href: '/reports/realtime-report',
            permissionKey: 'Real Time Report',
            id: 4
          },
          {
            title: 'Voice Broadcast Report',
            href: '/reports/broadcast-report',
            permissionKey: 'Voice Broadcast Report',
            id: 5
          }
        ]
      },
      {
        title: 'Call Details Report',
        id: 6,
        subItems: [
          {
            title: 'Daily Report',
            href: '/reports/daily-report',
            permissionKey: 'Daily Report',
            id: 7
          },
          {
            title: 'Dump Report',
            href: '/reports/dump-report',
            permissionKey: 'Dump Report',
            id: 8
          }
        ]
      },
      {
        title: 'Agent Performance',
        id: 9,
        subItems: [
          {
            title: 'Daily Agent Login Logout',
            href: '/reports/daily-agent-login-logout',
            permissionKey: 'Daily Agent Login Logout',
            id: 10
          },
          {
            title: 'Custom Agent Login Logout',
            href: '/reports/custom-agent-login-logout',
            permissionKey: 'Custom Agent Login Logout',
            id: 11
          }
        ]
      },
      {
        title: 'Download',
        id: 12,
        subItems: [
          {
            title: 'Recording Report',
            href: '/reports/recording-report',
            permissionKey: 'Recording Report',
            id: 13
          }
        ]
      },
      {
        title: 'DID Report',
        id: 14,
        subItems: [
          {
            title: 'DID Daily Report',
            href: '/reports/did-daily-report',
            permissionKey: 'DID Daily Report',
            id: 15
          },
          {
            title: 'DID Dump Report',
            href: '/reports/did-dump-report',
            permissionKey: 'DID Dump Report',
            id: 16
          }
        ]
      },
      {
        title: 'Product',
        id: 17,
        subItems: [
          {
            title: 'Product Report',
            href: '/reports/product-report',
            permissionKey: 'Product Report',
            id: 18
          }
        ]
      },
      {
        title: 'Voice Broadcast',
        id: 19,
        subItems: [
          {
            title: 'DTMF Report',
            href: '/reports/dtmf-report',
            permissionKey: 'DTMF Report',
            id: 20
          },
          {
            title: 'Call Connectivity Report',
            href: '/reports/call-connectivity-report',
            permissionKey: 'Call Connectivity Report',
            id: 21
          }
        ]
      },
      {
        title: 'Call Report',
        id: 22,
        subItems: [
          {
            title: 'Missed Call Report',
            href: '/reports/missed-call-report',
            permissionKey: 'Missed Call Report',
            id: 23
          },
          {
            title: 'Agent Performance Report',
            href: '/reports/agent-performance-report',
            permissionKey: 'Agent Performance Report',
            id: 24
          },
          {
            title: 'Agent Disposition Report',
            href: '/reports/agent-disposition-report',
            permissionKey: 'Agent Disposition Report',
            id: 25
          },
          {
            title: 'Audit Report',
            href: '/reports/tenant-audit-report',
            permissionKey: 'Audit Report',
            id: 26
          }
        ]
      },
      {
        title: 'Omni Channel Report',
        id: 27,
        subItems: [
          {
            title: 'Chat Report',
            href: '/reports/chat-report',
            permissionKey: 'Chat Report',
            id: 28
          },
          {
            title: 'Whatsapp Report',
            href: '/reports/whatsapp-report',
            permissionKey: 'Whatsapp Report',
            id: 29
          }
        ]
      },
      {
        title: 'Auditor',
        id: 30,
        subItems: [
          {
            title: 'Auditor Dashboard',
            href: '/reports/auditor-dashboard',
            permissionKey: 'Auditor Dashboard',
            id: 31
          },
          {
            title: 'Auditor Report',
            href: '/reports/auditor-report',
            permissionKey: 'Auditor Report',
            id: 32
          }
        ]
      }
    ]
  },
  {
    title: 'Configuration',
    id: 33,
    href: '/configuration',
    icon: <Icon.Settings size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Config',
        id: 34,
        subItems: [
          {
            title: 'Crms',
            href: '/configuration/crms',
            permissionKey: 'Crms',
            id: 35
          },
          {
            title: 'Users',
            href: '/configuration/users',
            permissionKey: 'Users',
            id: 36
          },
          {
            title: 'Process',
            href: '/configuration/process',
            permissionKey: 'Process',
            id: 37
          },
          {
            title: 'Lists',
            href: '/configuration/lists',
            permissionKey: 'Lists',
            id: 38
          },
          {
            title: 'Lead Retries',
            href: '/configuration/lead-retries',
            permissionKey: 'Lead Retries',
            id: 39
          },
          {
            title: 'DNC',
            href: '/configuration/dnc',
            permissionKey: 'DNC',
            id: 40
          },
          {
            title: 'Whatsapp Meta',
            href: '/configuration/whatsapp-meta',
            permissionKey: 'Whatsapp Meta',
            id: 41
          },
          {
            title: 'SMTP',
            href: '/configuration/smtp',
            permissionKey: 'SMTP',
            id: 42
          }
        ]
      },
      {
        title: 'Setting',
        id: 43,
        subItems: [
          {
            title: 'Disposition',
            href: '/configuration/setting/disposition',
            permissionKey: 'Disposition',
            id: 44
          },
          {
            title: 'Sub Disposition',
            href: '/configuration/setting/sub-disposition',
            permissionKey: 'Sub Disposition',
            id: 45
          },
          {
            title: 'Sub Sub Disposition',
            href: '/configuration/setting/sub-sub-disposition',
            permissionKey: 'Sub Sub Disposition',
            id: 46
          },
          {
            title: 'Breaks',
            href: '/configuration/setting/breaks',
            permissionKey: 'Breaks',
            id: 47
          },
          {
            title: 'Scripts',
            href: '/configuration/setting/scripts',
            permissionKey: 'Scripts',
            id: 48
          }
        ]
      },
      {
        title: 'Routing',
        id: 49,
        subItems: [
          {
            title: 'Trunks',
            href: '/configuration/routing/trunks',
            permissionKey: 'Trunks',
            id: 50
          },
          {
            title: 'Outbound Routes',
            href: '/configuration/routing/outbound',
            permissionKey: 'Outbound Routes',
            id: 51
          }
        ]
      },
      {
        title: 'Product',
        id: 52,
        subItems: [
          {
            title: 'Area',
            href: '/configuration/product/area',
            permissionKey: 'Area',
            id: 53
          },
          {
            title: 'Beat',
            href: '/configuration/product/beat',
            permissionKey: 'Beat',
            id: 54
          },
          {
            title: 'Outlet',
            href: '/configuration/product/outlet',
            permissionKey: 'Outlet',
            id: 55
          },
          {
            title: 'Product',
            href: '/configuration/product/lists',
            permissionKey: 'Product',
            id: 56
          }
        ]
      },
      {
        title: 'Omni Channel',
        id: 57,
        subItems: [
          {
            title: 'Whatsapp',
            href: '/configuration/omni-channel/whatsapp',
            permissionKey: 'Whatsapp',
            id: 58
          },
          {
            title: 'Whatsapp Templates',
            href: '/configuration/omni-channel/whatsapp-templates',
            permissionKey: 'Whatsapp Templates',
            id: 59
          },
          {
            title: 'Whatsapp Broadcast',
            href: '/configuration/omni-channel/whatsapp-broadcast',
            permissionKey: 'Whatsapp Broadcast',
            id: 60
          }
        ]
      },
      {
        title: 'Whatsapp Bot',
        id: 61,
        subItems: [
          {
            title: 'Whatsapp Bot Template',
            href: '/configuration/whatsapp-bot/template',
            permissionKey: 'Whatsapp Bot Template',
            id: 62
          },
          {
            title: 'Whatsapp Bot Flow',
            href: '/configuration/whatsapp-bot/flow',
            permissionKey: 'Whatsapp Bot Flow',
            id: 63
          },
          {
            title: 'Whatsapp Bot Broadcast',
            href: '/configuration/whatsapp-bot/broadcast',
            permissionKey: 'Whatsapp Bot Broadcast',
            id: 64
          }
        ]
      },
      {
        title: 'Whatsapp Meta',
        id: 65,
        subItems: [
          {
            title: 'Whatsapp Meta Template',
            href: '/configuration/whatsapp-meta/template',
            permissionKey: 'Whatsapp Meta Template',
            id: 66
          },
          {
            title: 'Whatsapp Meta Flow',
            href: '/configuration/whatsapp-meta/flow',
            permissionKey: 'Whatsapp Meta Flow',
            id: 67
          },
          {
            title: 'Whatsapp Meta Broadcast',
            href: '/configuration/whatsapp-meta/broadcast',
            permissionKey: 'Whatsapp Meta Broadcast',
            id: 68
          }
        ]
      },
      {
        title: 'Follow Up',
        id: 69,
        subItems: [
          {
            title: 'Follow Up',
            href: '/configuration/follow-up',
            permissionKey: 'Follow Up',
            id: 70
          }
        ]
      }
    ]
  },
  {
    title: 'Incoming',
    id: 71,
    href: '/incoming',
    icon: <Icon.PhoneIncoming size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Incoming',
        id: 72,
        subItems: [
          {
            title: 'DIDs',
            href: '/incoming/did',
            permissionKey: 'DIDs',
            id: 73
          },
          {
            title: 'Queues',
            href: '/incoming/queues',
            permissionKey: 'Queues',
            id: 74
          },
          {
            title: 'IVRs',
            href: '/incoming/ivr',
            permissionKey: 'IVRs',
            id: 75
          }
        ]
      },
      {
        title: 'Prompts',
        id: 76,
        subItems: [
          {
            title: 'Audio Prompts',
            href: '/incoming/prompts/audio-prompts',
            permissionKey: 'Audio Prompts',
            id: 77
          }
        ]
      }
    ]
  },
  {
    title: 'Monitoring',
    id: 78,
    href: '/monitoring',
    icon: <Icon.TrendingUp size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Supervisor',
        id: 79,
        subItems: [
          {
            title: 'Supervisor',
            href: '/monitoring/supervisor',
            permissionKey: 'Supervisor',
            id: 80
          },
          {
            title: 'Supervisor Role',
            href: '/monitoring/supervisor-role',
            permissionKey: 'Supervisor Role',
            id: 81
          }
        ]
      },
      {
        title: 'Auditor',
        id: 82,
        subItems: [
          {
            title: 'Auditor',
            href: '/monitoring/auditor',
            permissionKey: 'Auditor',
            id: 83
          },
          {
            title: 'Auditor Category',
            href: '/monitoring/auditor-category',
            permissionKey: 'Auditor Category',
            id: 84
          },
          {
            title: 'Manual Auditor',
            href: '/monitoring/manual-auditor',
            permissionKey: 'Manual Auditor',
            id: 85
          }
        ]
      }
    ]
  }
];

export const AdminSidebarData = [
  {
    title: 'Dashboard',
    href: '/admin-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Companies',
    href: '/companies',
    id: 2,
    icon: <Icon.Users size={20} />,
    collapisble: false
  },
  {
    title: 'Module Permissions',
    href: '/module-permission',
    id: 3,
    icon: <Icon.UserCheck size={20} />,
    collapisble: false
  },
  {
    title: 'Company Role',
    href: '/company-role',
    id: 4,
    icon: <Icon.Layers size={20} />,
    collapisble: false
  },
  {
    title: 'Timezone',
    href: '/timezone',
    id: 5,
    icon: <Icon.Clock size={20} />,
    collapisble: false
  },
  {
    title: 'Branding',
    href: '/branding',
    id: 6,
    icon: <Icon.Image size={20} />,
    collapisble: false
  }
];

export const AuditorSidebarData = [
  {
    title: 'Dashboard',
    href: '/auditor-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Reports',
    id: 2,
    href: '/reports',
    icon: <Icon.FileText size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Audit Report',
        id: 3,
        subItems: [
          {
            title: 'Audit Report',
            href: '/reports/audit-report',
            permissionKey: 'Audit Report',
            id: 4
          }
        ]
      }
    ]
  }
];

export const IframeSidebarData = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    id: 'dashboard',
    i18nTitle: 'dashboard',
    icon: <Icon.Home size={20} />,
    collapisble: false
  }
];

export const IframeCrmSideBarData = [
  {
    title: 'CRM',
    href: '/crm',
    id: 'crm',
    i18nTitle: 'crm',
    icon: <Icon.Users size={20} />,
    collapisble: false
  }
];
